import {useTranslation} from "react-i18next";
import React from "react";
import {Col, Form, Row} from "react-bootstrap";
import {Block, DataTypeInput, DatePicker, FormGroup, Select} from "../../components";
import PropTypes from "prop-types";
import {usePropState} from "../../utils";
import { useGetCurrentUserQuery } from "../../../api/userApiSlice";

export default function StreamGeneralForm({formData, getInputProps, disabled,  ...props}) {
  const { t } = useTranslation();
  const {isValid, isInvalid, errors} = getInputProps("data_type")
  const dataTypesProps = {isValid, isInvalid, errors}
  const [bucket,] = usePropState(props.bucket)
  const {data: {isAdmin: userIsAdmin} = {}, isSuccess} = useGetCurrentUserQuery()


  return (
    <React.Fragment>
      <Block title={t("stream.dataTypes")} {...dataTypesProps} >
        <DataTypeInput {...getInputProps("data_type")} />
      </Block>
      <Block title={t("stream.general")}>
        <Form>
          <Form.Row>
            <FormGroup
              as={Col}
              label={t("stream.name")}
              input="text"
              placeholder="Default"
              text={t("stream.nameText")}
              {...getInputProps("name")}/>
            <FormGroup
              as={Col}
              label="&nbsp;"
              input="text"
              placeholder="root"
              pre={`s3://data-stream-partners-sink/${bucket}/`}
              {...getInputProps("stream")}
              disabled={userIsAdmin ? getInputProps("stream").disabled : true}/>
          </Form.Row>
          <Form.Row>
            <FormGroup
              as={Col}
              input={DatePicker}
              label={t("stream.startDate")}
              text={t("stream.startDateText")}
              placeholder={t("stream.now")}
              {...getInputProps("start_date")}/>
            <FormGroup
              as={Col}
              label={t("stream.endDate")}
              input={DatePicker}
              extraChildProps={{isClearable: true}}
              text={t("stream.endDateText")}
              {...getInputProps("end_date")}/>
          </Form.Row>
        </Form>
      </Block>
    </React.Fragment>
  )
}

StreamGeneralForm.propTypes = {
  formData: PropTypes.object,
  getInputProps: PropTypes.func, able: PropTypes.bool
}
